import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading, isAuthed } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center" data-testid="auth-loading">
        <div className="glass rounded-2xl px-6 py-4 text-sm text-muted-foreground">Signing you in…</div>
      </div>
    );
  }
  if (!isAuthed) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }
  if (roles && !roles.includes(user?.role) && !(roles.includes("admin") && user?.role === "superadmin")) {
    return <Navigate to="/" replace />;
  }
  return children;
}
